<template>
  <div class="frame">
    <img class="frame-img" :src="imgSrc">
  </div>
</template>

<script>
export default {
  //https://s3-us-west-2.amazonaws.com/s.cdpn.io/71829/mona-lisa.jpg" alt="Mona Lisa
  props: {
    imgSrc: {
      type: String,
    },
  },
};
</script>

<style lang="less" scoped>
@media screen and (max-width: 426px) {
  .frame {
    width: 100%;
  }
}
@media screen and (min-width: 768px) {
  .frame {
    width: 500px;
  }
}

.frame {
  background-color: #fff;
  border: solid 5vmin #eee;
  border-bottom-color: #fff;
  border-left-color: #eee;
  border-radius: 2px;
  border-right-color: #eee;
  border-top-color: #ddd;
  box-shadow: 3px 3px 20px rgba(0, 0, 0, 0.5);
  box-sizing: border-box;
  display: inline-block;
  position: relative;
  text-align: center;
  &:before {
    border-radius: 2px;
    bottom: -2vmin;
    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.25) inset;
    content: '';
    left: -2vmin;
    position: absolute;
    right: -2vmin;
    top: -2vmin;
  }
  &:after {
    border-radius: 2px;
    bottom: -2.5vmin;
    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.25);
    content: '';
    left: -2.5vmin;
    position: absolute;
    right: -2.5vmin;
    top: -2.5vmin;
  }
  .frame-img {
    max-height: 100%;
    max-width: 100%;
  }
}
</style>